<template>
  <div id="app">
    <Navbar/>
    <div class="container">
      <router-view/>
    </div>    
  </div>
</template>

<script>
import Navbar from './components/Navbar'
export default {
  name: 'App',
  components: {
    Navbar
  }
}
</script>

<style>
#app {
  
}
</style>



// WEBPACK FOOTER //
// src/App.vue